import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IsFavoriteQueryVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
}>;


export type IsFavoriteQuery = { isFavorite: boolean };

export type ToggleFavoriteMutationVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
}>;


export type ToggleFavoriteMutation = { toggleFavorite: { isFavorite: boolean } };


export const IsFavoriteDocument = gql`
    query IsFavorite($hierarchyId: String!, $nodeId: String!) {
  isFavorite(hierarchyId: $hierarchyId, nodeId: $nodeId)
}
    `;

/**
 * __useIsFavoriteQuery__
 *
 * To run a query within a React component, call `useIsFavoriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsFavoriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsFavoriteQuery({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useIsFavoriteQuery(baseOptions: Apollo.QueryHookOptions<IsFavoriteQuery, IsFavoriteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsFavoriteQuery, IsFavoriteQueryVariables>(IsFavoriteDocument, options);
      }
export function useIsFavoriteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsFavoriteQuery, IsFavoriteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsFavoriteQuery, IsFavoriteQueryVariables>(IsFavoriteDocument, options);
        }
export type IsFavoriteQueryHookResult = ReturnType<typeof useIsFavoriteQuery>;
export type IsFavoriteLazyQueryHookResult = ReturnType<typeof useIsFavoriteLazyQuery>;
export type IsFavoriteQueryResult = Apollo.QueryResult<IsFavoriteQuery, IsFavoriteQueryVariables>;
export const ToggleFavoriteDocument = gql`
    mutation ToggleFavorite($hierarchyId: String!, $nodeId: String!) {
  toggleFavorite(hierarchyId: $hierarchyId, nodeId: $nodeId) {
    isFavorite
  }
}
    `;
export type ToggleFavoriteMutationFn = Apollo.MutationFunction<ToggleFavoriteMutation, ToggleFavoriteMutationVariables>;

/**
 * __useToggleFavoriteMutation__
 *
 * To run a mutation, you first call `useToggleFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFavoriteMutation, { data, loading, error }] = useToggleFavoriteMutation({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useToggleFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFavoriteMutation, ToggleFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFavoriteMutation, ToggleFavoriteMutationVariables>(ToggleFavoriteDocument, options);
      }
export type ToggleFavoriteMutationHookResult = ReturnType<typeof useToggleFavoriteMutation>;
export type ToggleFavoriteMutationResult = Apollo.MutationResult<ToggleFavoriteMutation>;
export type ToggleFavoriteMutationOptions = Apollo.BaseMutationOptions<ToggleFavoriteMutation, ToggleFavoriteMutationVariables>;